import styled from 'styled-components'
import { colorTheme } from '../../../../../../style/theme/colorTheme'

export const TseErstbestellungBlock = styled.div`
	display: flex;
	justify-content: center;
	gap: 0.375em;
	padding: 0.25em 0;
	font-size: 0.8125em;
`
TseErstbestellungBlock.displayName = 'TseErstbestellungBlock'

export const Label = styled.span`
	font-weight: 600;
	color: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.labelText};
`
Label.displayName = 'TseErstbestellungLabel'

export const Value = styled.span`
	color: ${colorTheme.restaurant.orders.modalOrder.abortedHeader.valueText};
`
Value.displayName = 'TseErstbestellungValue'
